import { endpoints, host } from '@config/endpoints';
import request from './request';

export const exportTopSkillsByISCO4 = async (urlDataAPI: any) => {
    const { exportType, hubIds, isco4Codes, type } = urlDataAPI;

    const { path, method } = endpoints.skill.exportTopSkillsByISCO4;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { exportType, hubIds, isco4Codes, type },
            {
                responseType: "blob"
            },
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
